// * * ref: https://usehooks.com/useOnClickOutside/
import { useEffect, RefObject } from 'react'

type FnType = (
  ref: RefObject<HTMLElement | null>,
  handler: (e: Event) => void
) => void

const useOnClickOutside: FnType = (ref, handler) => {
  useEffect(() => {
    const listener = (event: TouchEvent | MouseEvent) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return
      }
      handler(event)
    }
    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)
    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler])
}

export default useOnClickOutside
